(function () {
  var root = document.querySelector('[data-gift-opt]');
  if (!root) return;

  var toggle = root.querySelector('[data-gift-toggle]');
  var errorEl = root.querySelector('[data-gift-error]');
  var productForm = document.querySelector('product-form');
  var form = productForm && productForm.querySelector('form[action*="/cart/add"]');
  var addonId = Number(root.dataset.giftVariantId);
  if (!toggle || !productForm || !form || !addonId) return;

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function revertAddon(previousQty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(addonId), quantity: previousQty })
    }).catch(function () {});
  }

  // Capture phase on <product-form> so this runs before the theme's own submit handler.
  productForm.addEventListener('submit', function (e) {
    if (!toggle.checked || productForm.dataset.giftAdded === '1') return;

    e.preventDefault();
    e.stopPropagation();
    errorEl.hidden = true;
    var submitter = e.submitter;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: addonId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('gift-add-failed');
        return r.json();
      })
      .then(function (data) {
        var added = (data.items && data.items[0]) || data;
        var previousQty = Math.max(0, (added.quantity || 1) - 1);

        productForm.dataset.giftAdded = '1';
        if (form.requestSubmit) {
          form.requestSubmit(submitter || undefined);
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        delete productForm.dataset.giftAdded;

        // If the product itself could not be added (e.g. sold out), do not leave the gift add-on alone in the cart.
        setTimeout(function () {
          var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
          if (wrapper && !wrapper.hasAttribute('hidden')) revertAddon(previousQty);
        }, 3000);
      })
      .catch(function () {
        showError('Δεν ήταν δυνατή η προσθήκη της επιλογής δώρου. Δοκίμασε ξανά.');
      });
  }, true);
})();